import { render } from "./ReportsTable.vue?vue&type=template&id=3ab76040"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__